import React from 'react';
import { formatToDateTime } from './jwtUtils';
import HeaderPublic from '../Layout/HeaderPublic';
import ContentPublic from './ContentPublic';
import './ValidadorResultado.css';

const cardStyle = { borderLeft: '4px solid var(--bs-primary)', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };

function ValidadorResultado({ resultado, onVoltar, onValidarCertificado }) {
    const { tipo, data } = resultado;

    if (tipo === 'certificado') {
        return <ResultadoCertificado data={data} onVoltar={onVoltar} />;
    } else if (tipo === 'matricula') {
        return <ResultadoMatricula data={data} onVoltar={onVoltar} onValidarCertificado={onValidarCertificado} />;
    }

    return null;
}

function parseJsonOrArray(val) {
    if (!val) return null;
    if (Array.isArray(val)) return val;
    if (typeof val === 'string') {
        try { return JSON.parse(val); } catch { return null; }
    }
    return null;
}

function ResultadoCertificado({ data, onVoltar }) {
    const { certificado, aulasConcluidas, logs = [], avaliacoesReacao = [], praticasRegistradas = [], status } = data;
    
    const getStatusBadge = () => {
        const statusClasses = {
            'Ativo': 'bg-success',
            'Expirado': 'bg-danger'
        };
        return (
            <span className={`badge ${statusClasses[status] || 'bg-secondary'}`}>{status}</span>
        );
    };

    return (
        <ContentPublic>
            <HeaderPublic />
            <div className="min-vh-100 d-flex flex-column validador-resultado" style={{ paddingTop: '100px' }}>
                {/* Header */}
                <div className="validador-header-bar">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-xl-10">
                                <div className="d-flex align-items-center justify-content-center position-relative py-3">
                                    <h4 className="validador-title mb-0 d-flex align-items-center gap-2">
                                        <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '1.35rem' }}></i>
                                        Certificado Validado
                                    </h4>
                                    <button className="btn btn-primary btn-sm position-absolute end-0" onClick={onVoltar}>
                                        Nova Validação
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Conteúdo */}
                <div className="container flex-grow-1 py-4">
                    <div className="row justify-content-center">
                        <div className="col-12 col-xl-10">
                            {/* Card Principal */}
                            <div className="card validador-card mb-4" style={cardStyle}>
                                <div className="card-header validador-card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="validador-card-title mb-0">{certificado.nomeCurso}</h5>
                                        </div>
                                        <div className="col-auto">{getStatusBadge()}</div>
                                    </div>
                                </div>
                                <div className="card-body p-4 p-md-5">
                                    <div className="row g-4">
                                        <div className="col-12 col-md-6">
                                            <div className="validador-section">
                                                <h6 className="validador-section-title">Informações do Aluno</h6>
                                                <div className="validador-info-list">
                                                    <div className="validador-info-item">
                                                        <span className="validador-label">Nome Completo</span>
                                                        <span className="validador-value validador-value-highlight">{certificado.nomeAluno}</span>
                                                    </div>
                                                    <div className="validador-info-item">
                                                        <span className="validador-label">Matrícula</span>
                                                        <span className="validador-value">{certificado.matricula}</span>
                                                    </div>
                                                    <div className="validador-info-item">
                                                        <span className="validador-label">Unidade</span>
                                                        <span className="validador-value">{certificado.unidade}</span>
                                                    </div>
                                                    <div className="validador-info-item">
                                                        <span className="validador-label">Horário da Assinatura</span>
                                                        <span className="validador-value">
                                                            {(() => {
                                                                const anoCert = new Date(certificado.data).getFullYear();
                                                                const praticasMesmoAno = praticasRegistradas.filter(
                                                                    (p) => new Date(p.data_treinamento).getFullYear() === anoCert
                                                                );
                                                                if (praticasMesmoAno.length > 0) {
                                                                    const maisRecente = [...praticasMesmoAno].sort(
                                                                        (a, b) => new Date(b.data_treinamento) - new Date(a.data_treinamento)
                                                                    )[0];
                                                                    return formatToDateTime(maisRecente.data_treinamento);
                                                                }
                                                                return formatToDateTime(certificado.pdf_gerado_em || certificado.data);
                                                            })()}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <div className="validador-section">
                                                <h6 className="validador-section-title">Informações do Curso</h6>
                                                <div className="validador-info-list">
                                                    <div className="validador-info-item">
                                                        <span className="validador-label">Carga Horária</span>
                                                        <span className="validador-value">{certificado.cargaHorariaTotal} horas</span>
                                                    </div>
                                                    <div className="validador-info-item">
                                                        <span className="validador-label">Tópico</span>
                                                        <span className="validador-value">{certificado.nomeTopico}</span>
                                                    </div>
                                                    {certificado.prazo_validade > 0 && (
                                                        <div className="validador-info-item">
                                                            <span className="validador-label">Prazo de Validade</span>
                                                            <span className="validador-value">
                                                                {certificado.prazo_validade} {certificado.prazo_validade === 1 ? 'mês' : 'meses'}
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Aulas Concluídas */}
                            {aulasConcluidas.length > 0 && (
                                <div className="card validador-card mb-4" style={cardStyle}>
                                    <div className="card-header validador-card-header">
                                        <h6 className="validador-section-title mb-0">Aulas Concluídas ({aulasConcluidas.length})</h6>
                                    </div>
                                    <div className="card-body p-0">
                                        <div className="table-responsive">
                                            <table className="table validador-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th className="validador-th" style={{ width: '22%' }}>Módulo</th>
                                                        <th className="validador-th" style={{ width: '48%' }}>Aula</th>
                                                        <th className="validador-th text-end" style={{ width: '30%' }}>Data e Hora</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {aulasConcluidas.map((aula, index) => (
                                                        <tr key={index} className={index % 2 === 1 ? 'validador-tr-alt' : ''}>
                                                            <td className="validador-td">{aula.moduloNome}</td>
                                                            <td className="validador-td">
                                                                <span className="validador-td-main">{aula.titulo}</span>
                                                                {aula.descricao && <span className="validador-td-sub d-block mt-0">{aula.descricao}</span>}
                                                            </td>
                                                            <td className="validador-td text-end">{formatToDateTime(aula.dataConclusao)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Avaliações de Reação */}
                            {avaliacoesReacao.length > 0 && avaliacoesReacao.map((avaliacao, idx) => {
                                const reacaoQuestoes = parseJsonOrArray(avaliacao.questoes);
                                const reacaoRespostas = parseJsonOrArray(avaliacao.respostas);
                                const tipoLabel = avaliacao.tipo === 'hibrido' ? 'Reação Híbrida' : 'Reação Presencial';
                                return (
                                    <div key={idx} className="card validador-card mb-4" style={cardStyle}>
                                        <div className="card-header validador-card-header">
                                            <h6 className="validador-section-title mb-0">
                                                Avaliação de {tipoLabel}
                                                {avaliacao.moduloNome && <span className="fw-normal text-muted"> — {avaliacao.moduloNome}</span>}
                                            </h6>
                                        </div>
                                        <div className="card-body">
                                            <p className="validador-meta mb-3">Realizada em {formatToDateTime(avaliacao.data)}</p>
                                            {reacaoQuestoes && reacaoRespostas && reacaoQuestoes.length > 0 && (
                                                <div className="table-responsive">
                                                    <table className="table validador-table mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th className="validador-th" style={{ width: '70%' }}>Pergunta</th>
                                                                <th className="validador-th" style={{ width: '30%' }}>Resposta</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {reacaoQuestoes.map((q, i) => (
                                                                <tr key={i} className={i % 2 === 1 ? 'validador-tr-alt' : ''}>
                                                                    <td className="validador-td">{q}</td>
                                                                    <td className="validador-td">{reacaoRespostas[i] ?? '—'}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}
                                            {avaliacao.comentarios && (
                                                <div className="mt-3 pt-3 border-top">
                                                    <span className="validador-label d-block mb-1">Comentários</span>
                                                    <p className="validador-value mb-0">{avaliacao.comentarios}</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}

                            {/* Práticas Registradas */}
                            {praticasRegistradas.length > 0 && (
                                <div className="card validador-card mb-4" style={cardStyle}>
                                    <div className="card-header validador-card-header">
                                        <h6 className="validador-section-title mb-0">Práticas Registradas ({praticasRegistradas.length})</h6>
                                    </div>
                                    <div className="card-body p-0">
                                        <div className="table-responsive">
                                            <table className="table validador-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th className="validador-th" style={{ width: '20%' }}>Data Treinamento</th>
                                                        <th className="validador-th" style={{ width: '28%' }}>Local</th>
                                                        <th className="validador-th" style={{ width: '22%' }}>Gestor</th>
                                                        <th className="validador-th text-end" style={{ width: '30%' }}>Data Registro</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {praticasRegistradas.map((pratica, idx) => (
                                                        <tr key={idx} className={idx % 2 === 1 ? 'validador-tr-alt' : ''}>
                                                            <td className="validador-td">{formatToDateTime(pratica.data_treinamento)}</td>
                                                            <td className="validador-td">{pratica.local_treinamento}</td>
                                                            <td className="validador-td">{pratica.gestor}</td>
                                                            <td className="validador-td text-end">{formatToDateTime(pratica.data_registro)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Logs de Atividade */}
                            {logs.length > 0 && (
                                <div className="card validador-card mb-4" style={cardStyle}>
                                    <div className="card-header validador-card-header">
                                        <h6 className="validador-section-title mb-0">Logs de Atividade</h6>
                                        <span className="validador-meta d-block mt-0">Por data e aulas/módulos do curso</span>
                                    </div>
                                    <div className="card-body p-0">
                                        <div className="table-responsive">
                                            <table className="table validador-table validador-table-sm mb-0">
                                                <thead>
                                                    <tr>
                                                        <th className="validador-th" style={{ width: '18%' }}>Data e Hora</th>
                                                        <th className="validador-th" style={{ width: '66%' }}>Ação</th>
                                                        <th className="validador-th text-end" style={{ width: '16%' }}>IP</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {logs.map((log, index) => (
                                                        <tr key={index} className={index % 2 === 1 ? 'validador-tr-alt' : ''}>
                                                            <td className="validador-td">{formatToDateTime(log.data)}</td>
                                                            <td className="validador-td">{log.acao}</td>
                                                            <td className="validador-td text-end">
                                                                {log.ip ? <code className="validador-code">{log.ip}</code> : <span className="text-muted">—</span>}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Aviso de Status */}
                            {status !== 'Ativo' && (
                                <div className="alert alert-warning validador-alert mb-0">
                                    <strong>Atenção: </strong> Este certificado está expirado.
                                    {status === 'Expirado' && ' Verifique a data de validade.'}
                                    {status === 'Arquivado' && ' Este certificado foi substituído por uma nova versão.'}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </ContentPublic>
    );
}

function ResultadoMatricula({ data, onVoltar, onValidarCertificado }) {
    const { usuario, certificados } = data;
    const cardStyle = { borderLeft: '4px solid var(--bs-primary)', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };

    return (
        <ContentPublic>
            <HeaderPublic />
            <div className="min-vh-100 d-flex flex-column validador-resultado" style={{ paddingTop: '100px' }}>
                <div className="validador-header-bar">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-xl-10">
                                <div className="validador-matricula-header py-3">
                                    <div className="validador-matricula-header-info">
                                        <h4 className="validador-title mb-0">Certificados do Aluno</h4>
                                        <p className="validador-subtitle mb-0 mt-1">{usuario.nome_completo}</p>
                                    </div>
                                    <button className="btn btn-primary btn-sm validador-matricula-header-btn" onClick={onVoltar}>
                                        Nova Validação
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container flex-grow-1 py-4">
                    <div className="row justify-content-center">
                        <div className="col-12 col-xl-10">
                            {certificados.length > 0 ? (
                                <div className="card validador-card" style={cardStyle}>
                                    <div className="card-header validador-card-header">
                                        <h5 className="validador-card-title mb-0">Certificados Encontrados ({certificados.length})</h5>
                                    </div>
                                    <div className="card-body p-0">
                                        <div className="table-responsive">
                                            <table className="table validador-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th className="validador-th" style={{ width: '40%' }}>Curso</th>
                                                        <th className="validador-th text-end" style={{ width: '22%' }}>Data e Hora</th>
                                                        <th className="validador-th text-center" style={{ width: '14%' }}>Status</th>
                                                        <th className="validador-th text-end" style={{ width: '24%' }}>Ações</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {certificados.map((cert, idx) => (
                                                        <tr key={cert.id} className={idx % 2 === 1 ? 'validador-tr-alt' : ''}>
                                                            <td className="validador-td">
                                                                <span className="validador-td-main">{cert.nomeCurso}</span>
                                                                <span className="validador-td-sub d-block">ID: {cert.id}</span>
                                                            </td>
                                                            <td className="validador-td text-end">{formatToDateTime(cert.data)}</td>
                                                            <td className="validador-td text-center">
                                                                <span className={`badge ${cert.status === 'Ativo' ? 'bg-success' : 'bg-danger'}`}>
                                                                    {cert.status}
                                                                </span>
                                                            </td>
                                                            <td className="validador-td text-end">
                                                                <button className="btn btn-primary btn-sm" onClick={() => onValidarCertificado(cert.id)}>
                                                                    Ver Detalhes
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="card validador-card" style={cardStyle}>
                                    <div className="card-body text-center py-5">
                                        <h5 className="validador-empty-title">Nenhum certificado encontrado</h5>
                                        <p className="validador-meta mb-0">Este aluno ainda não possui certificados emitidos.</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </ContentPublic>
    );
}

export default ValidadorResultado;